import { render, staticRenderFns } from "./statisticalAnalysis.vue?vue&type=template&id=685fbc0a&scoped=true&"
import script from "./statisticalAnalysis.vue?vue&type=script&lang=js&"
export * from "./statisticalAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./statisticalAnalysis.vue?vue&type=style&index=0&id=685fbc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685fbc0a",
  null
  
)

export default component.exports